import React from 'react';
import Pages from './Pages.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';



class Proof extends Pages {
    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }
    leftmenu = () => {
        return (

            <div className='leftmenu'>
            </div>
        )
    }
    righttext = () => {
        return (
            <div className='righttext' style={{ width: '90%' }}>
                <h1 >Phase 0 - The SUMO cleavage and Double His-Pulldown Purification Scheme</h1>
                <br />
                As designed, we will be increasing the half-life of our AMP product Cecropin B via SUMO-tagging. SUMO-tagging underpins the basis for AMPed’s Phase I and Phase II. In Phase I, the SUMO-tag is used as a means of purification, by using the double His-pulldown purification scheme, this grants us a cheap and efficient purification scheme. In Phase II, the SUMO-tag is used as a means to preserve the AMP and inducibly trigger the activity of the AMP. With such an essential system underpinning the project, it is important that this system is first proven. In order to prove that this scheme can work for small protein components we have tested this system in a bacterial expression system.
                <br /><br />
                The tested proposed double His-pulldown purification scheme will be performed with two transformants. One expressing 6xHis-SUMO-RFP and 6xHis-Ulp1. With sonication and centrifugation, cell lysate from both transformed bacteria is purified using His-pulldown columns. Elutants of pure 6xHis-SUMO-RFP and 6xHis-Ulp1 are then incubated with each other to cleave the SUMO proteins, resulting in a mixture of 6xHis-SUMO, RFP, and 6xHis-Ulp1. With another His-pullown, the flowthrough hence will be containing RFP.
                <br /><br />
                To summarise our Results page: SDS-PAGE was run to confirm both strains were expressing the proteins. In the first His-pulldown, both 6xHis-Ulp1 and 6xHis-SUMO-RFP were successfully purified, as shown in the SDS-PAGE. Cleavage was demonstrated to achieve more than 95% completion. The reaction mixture was then subjected to the second His-pulldown and the flowthrough was run in SDS-PAGE again.
                <br /><br />
                <div style={{ textAlign: 'center' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/proof-of-concept/image1.png'} alt='' /> <br />
                    <i>Figure 1. SDS-PAGE showcasing SUMO-RFP cleavage</i><br /><br />
                    <img src={'https://static.igem.wiki/teams/4241/wiki/proof-of-concept/image2.png'} alt='' /><br />
                    <i>Figure 2. Microcentrifuge tubes of 6x-His-SUMO-RFP and 6xHis-SUMO and RFP</i><br /><br />
                </div>
                In the left microfuge tube, Ulp1 cleavage was not carried out. Therefore, all the 6xHis-SUMO-RFP was bound to the bead and sank as a red precipitate at the bottom. This showed the good binding capacity of the resin.  In the right microfuge tube, Ulp1 cleavage was carried out. RFP was released from the 6xHis-SUMO, and 6xHis-SUMO and 6xHis-Ulp1 were bound in the bead. A clear pink colour of the supernatant fraction showed that RFP was released and had no affinity towards the bead.
                <br /><br />
                The above summarised results clearly indicate the feasibility and usability of the SUMO-cleavage system and the double His-pulldown purification scheme. These results prove that this system is functional and an excellent candidate for future uses in Phase I, Phase II and beyond.
            </div>
        )
    }

    render() {
        return (
            <>
            {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
                <h1 className='des'>Proof Of Concept</h1>
                <div className='pageholder'>

                    {/* {this.leftmenu()} */}
                    {this.righttext()}
                </div>
            </>
        )
    }
}


export default Proof;
